import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/ui/icons';
import { useEffect } from 'react';
import { trackPaymentFailed } from '@/lib/analytics';

const CancelledPage = () => {
  useEffect(() => {
    trackPaymentFailed('provider_platform_fee', 'checkout_cancelled', {
      source: 'billing',
    });
  }, []);

  return (
    <div className='mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 py-12'>
      <Card className='w-full'>
        <CardContent className='flex flex-col items-center gap-5 p-8 text-center'>
          <div className='flex size-14 items-center justify-center rounded-full bg-status-warning-light'>
            <Icons.AlertCircle className='size-7 text-status-warning' />
          </div>

          <div className='space-y-2'>
            <h1 className='text-xl font-semibold text-foreground'>Zahlung abgebrochen</h1>
            <p className='text-sm leading-relaxed text-muted-foreground'>Der Zahlungsvorgang wurde nicht abgeschlossen. Es wurde nichts berechnet. Sie können die Zahlung jederzeit über die Dienstdetails erneut starten.</p>
          </div>

          <div className='w-full pt-2'>
            <Button className='w-full' render={<Link to='/provider/services' />}>
              Zurück zu meinen Diensten
              <Icons.ArrowRight className='ml-2 size-4' />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const Route = createFileRoute('/provider/payment/cancelled')({
  component: CancelledPage,
});
